<template>
	<div>
		<Form :model="searchForm" :label-width="80" inline>
			<FormItem label="查询">
				<Input v-model="searchForm.queryInput" placeholder="请输入关键字" @on-change="filterEvent"></Input>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="addAddressBtn('新增邮寄地址')">新增邮寄地址</Button>
			</FormItem>
		</Form>
			<Page :total="filterList.length" show-sizer @on-change="changePage" @on-page-size-change="changePageSize"></Page>
			<Table :columns="columnsAddress" :data="tableList"></Table>
		<Modal v-model="modalDisplay" ref="addressModal" :loading="true" :title="modalTitle"  @on-ok="editAddress">
				<Form :model="addressModal" ref="addressForm" :rules="validateForm">
					<FormItem label="收件人" :label-width="100" prop="realname">
						<Input v-model="addressModal.realname" placeholder="请输入关键字"></Input>
					</FormItem>
					<FormItem label="发票抬头" :label-width="100" prop="title">
						<Input v-model="addressModal.title" placeholder="请输入关键字"></Input>
					</FormItem>
					<FormItem label="发票类型" :label-width="100" prop="titleType">
						<RadioGroup v-model="addressModal.titleType">
							<Radio label="2">企业</Radio>
							<Radio label="1">个人</Radio>
						</RadioGroup>
					</FormItem>
					<FormItem label="电话号码" :label-width="100" prop="phone">
						<Input v-model="addressModal.phone" placeholder="请输入关键字"></Input>
					</FormItem>
					<FormItem label="省份" :label-width="100" prop="province">
						<Select v-model="addressModal.province" @on-change="changeProvice" transfer>
							<Option v-for="option in privoicesList" :value="option.id" :key="option.id">
								{{ option.name }}
							</Option>
						</Select>
					</FormItem>
					<FormItem label="市" :label-width="100" prop="city">
						<Select v-model="addressModal.city" @on-change="changeCity" transfer>
							<Option v-for="option in citiesList" :value="option.id" :key="option.name">
								{{ option.name }}
							</Option>
						</Select>
					</FormItem>
					<FormItem label="地区" :label-width="100" prop="county">
						<Select transfer v-model="addressModal.county">
							<Option v-for="option in countiesList" :key="option.name" :value="option.id">
								{{ option.name }}
							</Option>
						</Select>
					</FormItem>
					<FormItem label="详细地址" :label-width="100" prop="address">
						<Input v-model="addressModal.address" placeholder="请输入关键字"></Input>
					</FormItem>
					<FormItem label="邮政编码" :label-width="100" prop="code">
						<Input v-model="addressModal.code" placeholder="请输入关键字"></Input>
					</FormItem>
				</Form>
		</Modal>
	</div>
</template>
<script>  
import { phoneRegular } from "../../../utils/regular";
export default {
	props:['privoicesList','citiesList','countiesList','postAddress'],
	watch: {
		postAddress(val) {
			if(val.length>=0){
				this.filterList = this.allDate = val;
				this.pagePagin();
			}
		}
	},
	data () {
		return {
			allDate: [],
			tableList: [],
			filterList: [],
			page: 1,
			pageSize: 10,
			searchForm: {
				queryInput: '',
				typeSelect: '',
				addressInput: '',
				mailingInput: '',
			},
			addressModal: {},
			modalTitle: '新增邮寄地址',
			modalDisplay: false,
			address: {
				address: '',
				addressId: '',
				realname: '',
				title: '',
				titleType: '1',
				phone: '',
				province: 1,
				city: 52791,
				county: 72,
				code: ''
			},
			validateForm: {
				address: [
					{ required: true, message: '请填写地址', trigger: 'blur' }
				],
				realname: [
					{ required: true, message: '请填写收件人', trigger: 'blur' }
				],
				title: [
					{ required: true, message: '请填写发票抬头', trigger: 'blur' }
				],
				titleType: [
					{ required: true, message: '请选择发票类型', trigger: 'change' }
				],
				phone: [
					{ required: true, message: '请填写电话号码', trigger: 'blur' },
					{ pattern: phoneRegular, message: '电话号码格式不正确', trigger: 'change' },
				],
				province: [
					{ required: true, type:'number', message: '请选择省份', trigger: 'change' }
				],
				city: [
					{ required: true, type:'number', message: '请选择城市', trigger: 'change' }
				],
				county: [
					{ required: true, type:'number', message: '请选择地区', trigger: 'change' }
				],
				code: [
					{ required: true, message: '请填写邮政编码', trigger: 'blur' }
				],
			},
			columnsAddress: [
				{
					title: '收件人',
					key: 'realname',
					align: 'center',
					width: 150,
				},
				{
					title: '发票抬头',
					align: 'center',
					width: 150,
					key: 'title'
				},
				{
					title: '电话号码',
					align: 'center',
					width: 150,
					key: 'phone'
				},
				{
					title: '省份',
					align: 'center',
					width: 150,
					key: 'provinceName'
				},
				{
					title: '市',
					align: 'center',
					width: 150,
					key: 'cityName'
				},
				{
					title: '地区',
					align: 'center',
					width: 150,
					key: 'countyName'
				},
				{
					title: '详细地址',
					align: 'center',
					width: 150,
					key: 'address'
				},
				{
					title: '邮政编码',
					align: 'center',
					width: 150,
					key: 'addressId'
				},
				{
					title: '操作',
					key: 'action',
					width: 150,
					align: 'center',
					render: (h, params) => {
						return h('div', [
								h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.addressModal = Object.assign({}, this.address, params.row);
											this.addAddressBtn('编辑邮寄地址');
										}
									}
								}, '编辑'),
								h('Button', {
									props: {
										type: 'error',
										size: 'small'
									},
									on: {
										click: () => {
											this.remove(params.row.addressId);
										}
									}
								}, '删除')
						]);
					}
				}
			]
		}
	},
	methods: {
		changePage(page) {
			this.page = page
			this.pagePagin()
		},
		changePageSize(size){
			this.page = 1;
			this.pageSize = size;
			this.pagePagin();
		},
		pagePagin() {
			this.tableList = this.filterList.slice(this.pageSize*(this.page-1),this.pageSize*this.page);
		},
		filterEvent() {
			this.page = 1;
			let key = this.searchForm.queryInput.trim();
			if(!key) {
				this.page = 1;
				this.filterList = this.allDate;
			}else{
				this.filterList = [];
				for(let i=0;i<this.allDate.length;i++){
					if(JSON.stringify(this.allDate[i]).indexOf(key)!=-1){
						this.filterList.push(this.allDate[i])
					}
				}
			}
			this.pagePagin(); 
		},
		addAddressBtn(title) {
			this.addressModal.titleType = String(this.addressModal.titleType);
			this.modalTitle = title;
			if(title == '新增邮寄地址') {
				this.addressModal = Object.assign({}, this.address);
			}
			this.modalDisplay = true;
			
		},
		editAddress() {
			this.$refs.addressModal.buttonLoading = false;
			console.info(this.addressModal);
			this.$refs.addressForm.validate((valid)=>{
				if(valid){
					this.$emit('addAddress', this.addressModal);
					this.modalDisplay = false;
				}
			})
		},
		remove (addressId) {
			this.$emit('delAdress',addressId);
		},
		changeProvice(val) {
			this.$emit('queryCity',val)
		},
		changeCity(val) {
			this.$emit('queryCounties',val)
		},
		changeSelect(val) {
			const param = { numberOfElements: val }
			this.$emit('queryChangeSelect',param)
		}
	}
}
</script>

  


// WEBPACK FOOTER //
// src/pages/vip/vip-detail/mailing-address.vue